import React, { useEffect, useState } from "react";
import apiClient from "../../apiClient";
import { SSO_URL } from "../../env";
import { GET_CARDS_DATA } from "../../apiClient/apiEndpoints";
import { formatRupees } from "../../Utils/common";

const Cards = ({ index, type, name, dateRange = null, showRsValue }) => {
  const [details, setDetails] = useState({});

  const getKeyValue = async () => {
    try {
      const [startDate, endDate] = dateRange || [];
      const params = {
        // startDate: startDate ? startDate : null,
        // endDate: endDate ? endDate : null,
      };
      let data = await apiClient(`${SSO_URL}${GET_CARDS_DATA}/${type}`, {
        params,
      });
      if (type === "resource") {
        setDetails({ count: data.count.total });
      } else {
        setDetails(data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getKeyValue();
  }, [type]);

  
  return (
    <>
      <div key={index} className="stat-item cardsValues">
        <p>{name}</p>
        <h6>{showRsValue ? formatRupees( details.count || 0) : ( details.count || 0) }</h6>
      </div>
    </>
  );
};

export default Cards;
